import { render, staticRenderFns } from "./WritingTopic.vue?vue&type=template&id=12695d61"
import script from "./WritingTopic.vue?vue&type=script&lang=js"
export * from "./WritingTopic.vue?vue&type=script&lang=js"
import style0 from "./WritingTopic.vue?vue&type=style&index=0&id=12695d61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports